module.exports = __webpack_public_path__ + "img/main_logo_large.31bdff5b.svg";